import { useRef } from 'react';
import { observer } from 'mobx-react-lite';

import { WebRoundId } from './webRoundId';
import { ResultsHistory } from './resultsHistory';
import { Wheel, WheelSectionWrapper } from '../common';

export const GameMainTopWrapper = observer(() => {
  const ref = useRef();

  return (
    <WheelSectionWrapper results={ResultsHistory}>
      <WebRoundId />
      <Wheel innerRef={ref} />
    </WheelSectionWrapper>
  );
});
